import React, { FunctionComponent } from 'react';
import { Button, Flex, Icon, TableCell, TableRow, Text } from '@bitrise/bitkit';
import { BuildAttributes, BuildDataSummary } from '@trace/types';
import getFormattedValue from '../../../utils/metric/getFormattedValue';
import BuildSuccessRate from '../BuildSuccessRate/BuildSuccessRate';
import StatusHistory from '../StatusHistory/StatusHistory';
import ChangeBadge from '../../ChangeBadge/ChangeBadge';

interface Props {
  dataSummary: BuildDataSummary;
  groupBy: keyof BuildAttributes;
  onClick?: () => void;
}

const BuildBreakdownTableRow: FunctionComponent<Props> = ({ dataSummary, groupBy, onClick }) => {
  return (
    <TableRow onClick={onClick}>
      <TableCell breakOn="none">{dataSummary[groupBy]}</TableCell>

      <TableCell breakOn="none">
        <Flex alignChildrenVertical="middle" direction="horizontal" gap="x3">
          <Flex>
            <Text>
              {getFormattedValue(
                'seconds',
                dataSummary.totalTimeSuccess / dataSummary.totalBuildsSuccess,
              )}
            </Text>
          </Flex>

          <Flex>
            <ChangeBadge change={dataSummary.trendChange} positiveDelta={-1} />
          </Flex>
        </Flex>
      </TableCell>

      <TableCell breakOn="none">{getFormattedValue('seconds', dataSummary.totalTime)}</TableCell>

      <TableCell shrink>
        <BuildSuccessRate
          radius={30}
          strokeWidthInner={4}
          strokeWidthOuter={8}
          textConfig="8"
          totalBuilds={dataSummary.totalBuilds}
          totalBuildsSuccess={dataSummary.totalBuildsSuccess}
        />
      </TableCell>

      <TableCell shrink>
        <StatusHistory builds={dataSummary.buildsTail} size={24} />
      </TableCell>

      {onClick && (
        <TableCell shrink>
          <Button level="tertiary" size="small">
            <Icon name="ChevronRight" />
          </Button>
        </TableCell>
      )}
    </TableRow>
  );
};

export default BuildBreakdownTableRow;
